module.exports = __webpack_public_path__ + "static/media/facebook_icon_blue.b4b41422.svg";